module.exports = __webpack_public_path__ + "img/ball_3.75a075f6.png";